import React, { useContext } from "react"

export type ExperimentPreviewContextType = string[]

export const useExperimentPreview = (): ExperimentPreviewContextType => {
  const allPageVariants = useContext(ExperimentPreviewContext)
  return allPageVariants
}

export const ExperimentPreviewContext =
  React.createContext<ExperimentPreviewContextType>([])

export const ExperimentPreviewProvider: React.FC<{
  children: React.ReactNode
  allPageVariants?: ExperimentPreviewContextType
}> = ({ children, allPageVariants = [] }) => {
  return (
    <ExperimentPreviewContext.Provider value={allPageVariants}>
      {children}
    </ExperimentPreviewContext.Provider>
  )
}
